
export default [{
	path: '/price-levels',
	component: () => import('@/components/price-levels/List')
}, {
	path: '/price-levels/:id/extensions',
	component: () => import('@/components/price-levels/ListExtensions')
}]
